"use strict";

exports.__esModule = true;
exports.RenderDataToComponents = void 0;
var _errors = require("../../common/errors");
var _dataset = require("../../entities/dataset");
var _schema = require("../../entities/schema");
var _makePropEntry = require("./make-prop-entry");
var _makeDatasetMetadataPropEntry = require("./make-dataset-metadata-prop-entry");
var _makeBehaviorRelatedProps = require("./make-behavior-related-props");
const RenderDataToComponents = ({
  formatter,
  dataStore,
  errorReporter,
  dataExpression,
  mediaUtils
}) => ({
  dataset,
  components,
  updatedComponentIds = []
}) => {
  const mapValuesToComponentProps = makeMapValuesToComponentProps({
    formatter,
    dataExpression,
    errorReporter,
    mediaUtils
  });
  const schema = dataStore.readSchema(dataset.collectionId);
  const referencedCollectionIds = _schema.Schema.getReferencedCollectionIds(schema);
  const schemas = dataStore.readSchemas(referencedCollectionIds);
  const recordReadOptions = _dataset.Dataset.getReadOptions(dataset);
  const records = dataStore.readRecords(recordReadOptions);
  const currentRecord = getCurrentRecord(dataset, records);
  const updatedComponents = updatedComponentIds.length !== 0 ? components.filter(component => updatedComponentIds.includes(component.id)) : components;
  for (const component of updatedComponents) {
    const propEntries = mapValuesToComponentProps({
      component,
      dataset,
      schema,
      schemas,
      currentRecord
    });
    if (propEntries.length) {
      try {
        component.setProps(Object.fromEntries(propEntries));
      } catch (error) {
        errorReporter.report(_errors.CoreError.of('Failed setting data to component', {
          cause: error
        }));
      }
    }
  }
};
exports.RenderDataToComponents = RenderDataToComponents;
const makeMapValuesToComponentProps = dependencies => dataContext => {
  const {
    component,
    dataset
  } = dataContext;
  const {
    connection
  } = component;
  const propEntries = [...(0, _makeBehaviorRelatedProps.makeBehaviorRelatedProps)(component, dataset), ...makeDataProps(connection)];
  for (const [propName, propConnection] of Object.entries(connection.properties)) {
    const propEntry = propConnection.type === 'datasetMetadata' ? (0, _makeDatasetMetadataPropEntry.makeDatasetMetadataPropEntry)({
      dataset,
      propName,
      propConnection
    }) : (0, _makePropEntry.makePropEntry)({
      ...dataContext,
      propName,
      propConnection
    }, dependencies);
    if (propEntry) {
      propEntries.push(propEntry);
    }
  }
  return propEntries;
};
const makeDataProps = connection => {
  const extraProps = [];
  for (const [name, value] of Object.entries(connection.data)) {
    extraProps.push([name, value]);
  }
  return extraProps;
};
const getCurrentRecord = (dataset, records) => {
  const currentRecordIndex = _dataset.Dataset.getCurrentRecordIndex(dataset);
  const currentRecord = records.at(currentRecordIndex);
  return currentRecord;
};
//# sourceMappingURL=render-data-to-components.js.map